<template>
  <div class="add-box">
    <el-form ref="userform" :model="userform" label-width="120px" class="user-form">
      <el-form-item label="用户名:">
        <el-input v-model="userform.username" placeholder="登录账号" class="user-input" />
      </el-form-item>

      <el-form-item label="所属部门:">
        <el-cascader
          ref="lastdept"
          :show-all-levels="false"
          :options="deptList"
          :props="optionProps"
          class="user-input"
          placeholder="所属部门"
          @change="selectchange"
        />
      </el-form-item>

      <el-form-item label="密码:">
        <el-input v-model="userform.password" placeholder="密码" class="user-input" />
      </el-form-item>
      <el-form-item label="邮箱:">
        <el-input v-model="userform.email" placeholder="邮箱" class="user-input" />
      </el-form-item>
      <el-form-item label="手机号:">
        <el-input
          v-model="userform.mobile"
          placeholder="手机号"
          class="user-input"
          maxlength="11"
        />
      </el-form-item>

      <el-form-item label="角色:">
        <el-checkbox-group v-model="userform.roleIdList">
          <el-checkbox
            v-for="(current, index) in roleList"
            :key="index"
            :label="current.roleId"
          >
            {{ current.roleName }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="状态:">
        <el-radio v-model="userform.status" label="0">禁用</el-radio>
        <el-radio v-model="userform.status" label="1">正常</el-radio>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click.prevent="submit">确定</el-button>
        <el-button type="warning" @click.prevent="back">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { Checkout } from '@/utils/checkout' // 校验数据
const _checkout = new Checkout()

export default {
  data() {
    return {
      deptList: [],
      optionProps: {
        expandTrigger: 'hover',
        emitPath: false,
        value: 'deptId',
        label: 'name',
        children: 'children'
      },
      roleList: [],
      deptInfo: [],
      userform: {
        username: '',
        deptId: '',
        deptName: '',
        password: '',
        email: '',
        mobile: '',
        roleIdList: [],
        status: '1'
      }
    }
  },

  created() {
    this.$emit('setCurrentMenu', '管理员管理')
    this.getdeptList()
    this.getroleList()
  },

  methods: {
    getdeptList() {
      const vm = this
      vm.axios
        .get(vm.homePath() + '/sys/dept/list')
        .then((res) => {
          const data = res.data
          vm.deptList = vm.filterNull(vm.toTreeData(data, 'parentId', 'deptId'))
        })
        .catch((error) => console.log(error))
    },

    filterNull(data) {
      const vm = this
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          data[i].children = undefined
        } else {
          vm.filterNull(data[i].children)
        }
      }
      return data
    },

    getroleList() {
      const vm = this
      vm.axios
        .get(vm.homePath() + '/sys/role/select')
        .then((response) => {
          if (response.data.status === '000000') {
            const data = response.data.list
            vm.roleList = data
          } else {
            console.log(response.data.message)
          }
        })
        .catch((error) => console.log(error))
    },

    selectchange(val) {
      this.userform.deptId = val
      this.userform.deptName = this.$refs['lastdept'].getCheckedNodes()[0].label
    },

    submit() {
      let past = true
      if (this.userform.username == '') {
        this.$alert('用户名不能为空', '提示')
        past = false
      } else if (this.userform.deptName == '') {
        this.$alert('请选择所属部门', '提示')
        past = false
      } else if (this.userform.password == '') {
        this.$alert('密码不能为空', '提示')
        past = false
      } else if (this.userform.email == '') {
        this.$alert('邮箱不能空', '提示')
        past = false
      } else if (_checkout.checkEmail(this.userform.email)) {
        this.$alert('邮箱地址不正确', '提示')
        past = false
      } else if (this.userform.mobile == '') {
        this.$alert('手机号不能空', '提示')
        past = false
      } else if (_checkout.checkMobile(this.userform.mobile)) {
        this.$alert('手机号码不正确', '提示')
        past = false
      } else if (this.userform.roleIdList == []) {
        this.$alert('请至少选择一个角色', '提示')
        past = false
      } else if (this.userform.username == '') {
        this.$alert('登录账户不能为空', '提示')
        past = false
      }

      if (past) {
        const vm = this
        vm.axios
          .post(vm.homePath() + '/sys/user/save', {
            deptId: vm.userform.deptId,
            deptName: vm.userform.deptName,
            email: vm.userform.email,
            mobile: vm.userform.mobile,
            password: vm.userform.password,
            roleIdList: vm.userform.roleIdList,
            status: vm.userform.status,
            username: vm.userform.username
          })
          .then((response) => {
            if (response.data.status === '000000') {
              vm.$alert('增加成功', '提示', {
                callback: () => {
                  vm.$router.push('/index/user')
                }
              })
            } else {
              console.log('保存失败：', response.data.message)
            }
          })
          .catch((error) => console.log(error))
      }
    },

    back() {
      this.$router.push('/index/user')
    }
  }
}
</script>

<style></style>
